import React from 'react';
import { useTranslation } from 'react-i18next';
import { HtmlTrans, SectionHeader, Typography } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  a: {
    textDecoration: 'none',
    color: theme.color.link.linkDefault01,
  },
}));

const IpsleInstruction = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader title="Important" />
      <Typography variant="h3">
        {t('amendment->>GroupSubjectAmendmentRegister.BeforeYouBegin')}
      </Typography>
      <ol>
        <li>
          <Typography variant="body1">
            {t('amendment->>GroupSubjectAmendmentRegister.Content1Ipsle')}
          </Typography>

          <li>
            <Typography variant="body1">
              {t('amendment->>GroupSubjectAmendmentRegister.Content2Ipsle')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              {t('amendment->>GroupSubjectAmendmentRegister.Content3Ipsle')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              {t('amendment->>GroupSubjectAmendmentRegister.Content4Ipsle')}
            </Typography>
          </li>
        </li>
      </ol>
      <Typography variant="body1">
        <HtmlTrans
          i18nKey="amendment->>GroupSubjectAmendmentRegister.ForMoreInformation"
          values={{
            aClass: classes.a,
          }}
        />
      </Typography>
    </>
  );
};
export default IpsleInstruction;
